import { DictionariesContext } from "../types/responses/DictionariesContext";
import { PDADataService } from './base/PDADataService';

export class DictionariesService extends PDADataService {
  protected prefixUrl: string = `Dictionaries`;

  get() {
    return this.api.get<DictionariesContext>(`${this.prefixUrl}/get`);
  }
}